<template>
  <div class="top-banner">
    <img v-if="bannerUrl" :src="bannerUrl | filterPicture" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      bannerUrl: (state) => state.room.bannerUrl
    })
  }  
}
</script>

<style lang="scss" scoped>
.top-banner {
  position: fixed;
  width: 100%;
  height: 3.66rem;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>